import { create } from 'zustand';
import type { LoadingState } from './loading.types';

// 'Loading...' là default của reducer cũ (initialState.loading.loadingText) —
// app hiển thị overlay loading ngay từ lần render đầu, phải giữ.
export const defaultLoadingState = {
  loadingText: 'Loading...',
};

/**
 * Computes the Zustand store hook holding the global loading state. Initializes from the default loading state and exposes setLoadingText, which sets the store's loadingText (defaulting to an empty string).
 *
 * @returns The Zustand hook for accessing and updating loading state.
 */
const useLoadingStore = create<LoadingState>()((set) => ({
  ...defaultLoadingState,
  setLoadingText: (loadingText = '') => set({ loadingText }),
}));

export default useLoadingStore;
